import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import GallerySection from "@/components/GallerySection";
import AboutSection from "@/components/AboutSection";
import ContactBanner from "@/components/ContactBanner";
import QuoteSection from "@/components/QuoteSection";
import Footer from "@/components/Footer";

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <Navigation />
      <main>
        <HeroSection isLoaded={isLoaded} />
        <ServicesSection />
        <GallerySection />
        <AboutSection />
        <ContactBanner />
        <QuoteSection />
      </main>
      <Footer />
    </div>
  );
}
